import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocationContext } from "../context/LocationContext";

const FinalCTA = () => {
  const navigate = useNavigate();
  const { city, setCity } = useLocationContext();
  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 6, md: 8 },
        background:
          "linear-gradient(135deg, rgba(13,59,102,0.95), rgba(13,59,102,0.85))",
        overflow: "hidden",
      }}
    >
      {/* ===== SUBTLE BRAND GLOW ===== */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            radial-gradient(circle at 20% 30%, rgba(244,211,94,0.18), transparent 45%),
            radial-gradient(circle at 80% 70%, rgba(244,211,94,0.12), transparent 50%)
          `,
          pointerEvents: "none",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            maxWidth: 700,
            mx: "auto",
            textAlign: "center",
          }}
        >
          {/* HEADING */}
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.9rem", md: "2.6rem" },
              fontWeight: 800,
              color: "#FFFFFF",
              letterSpacing: "-0.4px",
            }}
          >
            Discover{" "}
            <Box component="span" sx={{ color: "#F4D35E" }}>
              Places Near You
            </Box>
          </Typography>

          {/* SUBTEXT */}
          <Typography
            sx={{
              mt: 1.5,
              color: "rgba(255,255,255,0.9)",
              fontSize: { xs: "0.95rem", md: "1.05rem" },
              lineHeight: 1.6,
              maxWidth: 520,
              mx: "auto",
            }}
          >
            Explore trusted local places, services and attractions across cities
            — curated to help you find what matters nearby.
          </Typography>

          {/* CTA BUTTONS */}
          <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Button
              onClick={() => navigate("/city")}
              sx={{
                backgroundColor: "#F4D35E",
                color: "#0D3B66",
                fontWeight: 700,
                px: 4,
                py: 1.4,
                borderRadius: 999,
                textTransform: "none",
                boxShadow: "0 16px 40px rgba(244,211,94,0.45)",
                "&:hover": {
                  backgroundColor: "#E6BF3C",
                  boxShadow: "0 20px 50px rgba(244,211,94,0.55)",
                },
              }}
            >
              Browse Cities
            </Button>

            <Button
              onClick={() => navigate(`search?city=${city.toLowerCase()}`)}
              sx={{
                color: "#FFFFFF",
                fontWeight: 600,
                px: 4,
                py: 1.4,
                borderRadius: 999,
                textTransform: "none",
                border: "1px solid rgba(255,255,255,0.35)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.08)",
                },
              }}
            >
              Explore Nearby
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FinalCTA;
